import React from 'react';
import ExcelBulkUpload from '../../ExcelBulkUpload/ExcelBulkUpload';

const AttendanceBulkUpload = ({
  downloadExcel,
  excelFileReader,
  bulkUpload,
  loader,
  errorMessage,
}) => {
  return (
    <React.Fragment>
      <ExcelBulkUpload
        downloadExcel={downloadExcel}
        excelFileReader={excelFileReader}
        bulkUploadFile={bulkUpload}
        loader={loader}
      />
      {errorMessage ? (
        <div className="d-flex justify-content-center">
          <div className='alert alert-danger col-md-10'>{errorMessage}</div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default AttendanceBulkUpload;

